import React, { useEffect, useRef, useState } from 'react';
import { Text }                               from '@mantine/core';
import { Lightbox }                           from 'yet-another-react-lightbox';
import { Captions, Thumbnails, Zoom }         from 'yet-another-react-lightbox/plugins';
import useIsMounted                           from '@hooks/use-is-mounted';
import { S3_PROPERTY_BUCKET_URL }             from '@utils/network-utils';
import { usePropertyState }                   from "@core/providers/PropertyStateProvider";

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';


interface Props {
    open: boolean;
    onClose: () => void;
}

export const ImageGalleryModal: React.FC<Props> = ({
                                                       open,
                                                       onClose
                                                   }) => {

    const { getAllGalleryImages, selectedImageIndex } = usePropertyState();


    const mountLock = useRef(true);
    const isMounted = useIsMounted();

    const [data, setData] = useState([]);

    // THUMBNAIL CAROUSAL
    const [width, setWidth] = React.useState(120);
    const [height, setHeight] = React.useState(80);
    const [border, setBorder] = React.useState(1);
    const [borderRadius, setBorderRadius] = React.useState(4);
    const [padding, setPadding] = React.useState(4);
    const [gap, setGap] = React.useState(16);

    //CAROUSEL
    const [preload, setPreload] = React.useState(2);

    // ZOOM
    const [animationDuration, setAnimationDuration] = React.useState(500);
    const [maxZoomPixelRatio, setMaxZoomPixelRatio] = React.useState(1);
    const [zoomInMultiplier, setZoomInMultiplier] = React.useState(2);
    const [doubleTapDelay, setDoubleTapDelay] = React.useState(300);
    const [doubleClickDelay, setDoubleClickDelay] = React.useState(300);
    const [doubleClickMaxStops, setDoubleClickMaxStops] = React.useState(2);
    const [keyboardMoveDistance, setKeyboardMoveDistance] = React.useState(50);
    const [wheelZoomDistanceFactor, setWheelZoomDistanceFactor] = React.useState(100);
    const [pinchZoomDistanceFactor, setPinchZoomDistanceFactor] = React.useState(100);
    const [scrollToZoom, setScrollToZoom] = React.useState(true);

    useEffect(() => {

        if (mountLock.current) {
            mountLock.current = false;

            // console.log(files, 'gallery-files')
            // console.log(initialIndex, 'initialIndex')

            const arrayImage = getAllGalleryImages()?.map((file, idx) => {

                const imageSrc = `${S3_PROPERTY_BUCKET_URL}/${file.src}`;

                return {
                    ...file,
                    src: imageSrc,
                    title: <Text weight={400}>
                        {/*<IconBed size={30} stroke={1}/>*/}
                        {file.title}
                    </Text>,
                    key: idx,
                }
            });

            setData(arrayImage);
        }

    }, []);

    return isMounted && (
        <Lightbox
            open={open}
            index={selectedImageIndex}
            close={() => onClose()}
            slides={data}
            carousel={{ preload }}
            plugins={[Captions, Thumbnails, Zoom]}
            thumbnails={{
                position: 'bottom',
                width,
                height,
                border,
                borderRadius,
                padding,
                gap
            }}
            animation={{ swipe: 300, zoom: animationDuration }}
            zoom={{
                maxZoomPixelRatio,
                zoomInMultiplier,
                doubleTapDelay,
                doubleClickDelay,
                doubleClickMaxStops,
                keyboardMoveDistance,
                wheelZoomDistanceFactor,
                pinchZoomDistanceFactor,
                scrollToZoom
            }}
        />
    )

}
